/* LittleLegs Selling Plan Fix v5 — monthly default, localized banner */
(function(){
  var PLANS=[
    {id:"5900992760",name:"Hver M\u00e5ned",discount:20,valueType:"percentage"},
    {id:"5901025528",name:"Hver 2 M\u00e5neder",discount:15,valueType:"percentage"}
  ];
  function run(){
    var sel=document.getElementById("ll-freq-select");
    if(!sel)return;
    for(var i=sel.options.length-1;i>=0;i--){
      if(sel.options[i].textContent.indexOf("Hver")===-1)sel.remove(i);
    }
    if(sel.options.length<1){
      PLANS.forEach(function(p,i){
        var o=document.createElement("option");
        o.value=p.id;o.textContent=p.name;
        if(i===0)o.selected=true;
        sel.appendChild(o);
      });
    }
    var preferIdx=0;
    for(var pi=0;pi<sel.options.length;pi++){
      var txt=sel.options[pi].textContent;
      if(txt.indexOf("2")===-1 && txt.indexOf("3")===-1){preferIdx=pi;break;}
    }
    sel.selectedIndex=preferIdx;
    var jsonEl=document.getElementById("ll-product-json");
    if(!jsonEl)return;
    try{
      var d=JSON.parse(jsonEl.textContent);
      if(d.sellingPlans&&d.sellingPlans.length>0){
        var hasHver=false;
        for(var j=0;j<d.sellingPlans.length;j++){if(d.sellingPlans[j].name.indexOf("Hver")!==-1){hasHver=true;break;}}
        if(hasHver)return;
      }
    }catch(e){return;}
    var basePrice=d.comparePrice||d.price;
    var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||"EUR";
    function fmt(v){
      var s=(v/100).toFixed(2).replace(".",",");
      var pre=["EUR","USD","GBP"].indexOf(cur)!==-1;
      var sym={EUR:"\u20ac",DKK:" kr",USD:"$",GBP:"\u00a3",NOK:" kr",SEK:" kr",CHF:" CHF"}[cur]||" "+cur;
      return pre?sym+s:s+sym;
    }
    function updateDOM(planId){
      var disc=0;
      for(var i=0;i<PLANS.length;i++){if(PLANS[i].id===planId){disc=PLANS[i].discount;break;}}
      var subPrice=Math.round(basePrice*(1-disc/100));
      var saved=basePrice-subPrice;
      var banner=document.getElementById("ll-sub-banner");
      var recTag=document.getElementById("ll-rec-tag");
      if(banner){
        var recHTML=recTag?recTag.outerHTML:"";
        var bannerTmpl=(window.llT&&window.llT.mostPopularSave)||"Most Popular \u00b7 Save __PERCENT__%";
        banner.innerHTML=bannerTmpl.replace("__PERCENT__",disc)+" "+recHTML;
      }
      var sp=document.getElementById("ll-sub-price");
      if(sp)sp.textContent=fmt(subPrice);
      var cp=document.getElementById("ll-sub-compare");
      if(cp)cp.textContent=fmt(basePrice);
      var pb=document.getElementById("ll-per-bag");
      if(pb){
        var perBagTmpl=(window.llT&&window.llT.perBag)||"__PRICE__/bag";
        pb.textContent=perBagTmpl.replace("__PRICE__",fmt(subPrice));
      }
      var sb=document.getElementById("ll-save-badge");
      if(sb){
        if(saved>0){
          sb.style.display="";
          var saveTmpl=(window.llT&&window.llT.saveAmount)||"Save __AMOUNT__";
          sb.textContent=saveTmpl.replace("__AMOUNT__",fmt(saved).replace(/[^0-9,.]/g,"").trim());
        }
        else{sb.style.display="none";}
      }
      var cta=document.getElementById("ll-cta-btn");
      if(cta){
        var span=cta.querySelector("span");
        if(span){span.textContent=span.textContent.replace(/[\d]+[,\.]\d+/,(subPrice/100).toFixed(2).replace(".",","));}
      }
      var si=document.getElementById("ll-selling-plan");
      if(si)si.value=planId;
    }
    updateDOM(sel.value);
    sel.addEventListener("change",function(){updateDOM(sel.value);});
  }
  if(document.readyState==="complete"){setTimeout(run,100);}
  else{window.addEventListener("load",function(){setTimeout(run,100);});}
})();
